import React, { useState } from 'react';
import axios from './AxiosConfig';
import { useNavigate } from 'react-router-dom';
import "./styles/login.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './styles/otpbackup.module.css';
import Timer from './Timer';
import OtpInput from './OtpInput';

const VerifyBackupQrForm = ({ onNextStep }) => {
    const [otp, setOtp] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const handleRequestNewOtp = async () => {
        try {
            const response = await axios.get('/api/send_otp_and_redirect/');
            if (response.data.status === 'success') {
                setMessage('Un nuovo codice OTP è stato inviato alla tua email.');
                setError('');
            } else {
                setError('Errore durante l\'invio del nuovo codice OTP.');
                setOtp('');
            }
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                err?.response?.data?.error   ||
                "Errore durante l'invio del nuovo codice OTP."
            );
            setOtp('');
        }
    };

    const handleVerifyOtp = async (event) => {
        event.preventDefault();
        if (otp.length < 6) {
            setError('Inserisci un codice OTP completo.');
            return;
        }
        try {
            const response = await axios.post('/api/verify_backup_qr_otp/', { otp });
            if (response.data.status === 'success') {
            setError('');
            setMessage('');
            onNextStep('generate_qr');
            } else {
                setError(response.data?.error || 'OTP non valido o scaduto.');
                setOtp('');
            }
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                err?.response?.data?.error   ||
                err?.message ||
                "Errore durante la verifica dell'OTP."
                );
                setOtp(''); // reset OTP visivo
                }
    };

    const handleOtpChange = (value) => {
        setOtp(value);
    };
    const handleFieldFocus = () => {
        if (error) setError('');
    };

    return (
        <div className={`col-4 ${styles.lato_form}`}>
            <Timer/>
            <div className={`p-4 border rounded ${styles.containerloginform}`}>
                <div className={`p-4 border rounded ${styles.containerTesto}`}>
                    <h3>Verifica Backup</h3>
                </div>
                <div className={styles.messaggioErrore}>
                    {error && <div className="alert alert-danger">{error}</div>}
                    {message && <div className="alert alert-success">{message}</div>}
                </div>
                <div className={styles.login_form}>
                    <form onSubmit={handleVerifyOtp}>
                        <label htmlFor="otpCode">Inserisci l'OTP ricevuto tramite email per configurare nuovamente il tuo Authenticator:</label>
                        <div onClick={handleFieldFocus}>
                        <OtpInput length={6} value={otp} onOtpChange={handleOtpChange} />
                        </div>
                    <button type="submit" className={`btn btn-primary ${styles.btnVerify}`}>Verifica</button>
                    </form>
                </div>
                <div className={`text-center mt-3 ${styles.backup_Option}`}>
                    <p>Il tuo codice OTP è scaduto o hai problemi a riceverlo?</p>
                    <button onClick={handleRequestNewOtp} className={`btn btn-link ${styles.btnLink}`}>
                        Invia un nuovo codice OTP
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VerifyBackupQrForm;
